import { render, staticRenderFns } from "./quanyilist.vue?vue&type=template&id=0ecebf54"
import script from "./quanyilist.vue?vue&type=script&lang=js"
export * from "./quanyilist.vue?vue&type=script&lang=js"
import style0 from "./quanyilist.vue?vue&type=style&index=0&id=0ecebf54&prod&lang=scss"
import style1 from "./quanyilist.vue?vue&type=style&index=1&id=0ecebf54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports